import { FC } from "react";

import { useRemoveLineItemFromCartMutation } from "@store/services/shopify";

import { useAmplitude } from "@hooks/amplitude/useAmplitude";

import IconButton from "@mui/material/IconButton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { analyticEvents, brandColorTokens } from "@constants";

import { IRemoveLineItemButtonProperties } from "./RemoveLineItemButton.types";

const RemoveLineItemButton: FC<IRemoveLineItemButtonProperties> = ({ lineItemId, cartId, productType }) => {
  const { track } = useAmplitude();
  const [removeLineItem, { isLoading: isRemoveLineItemLoading }] = useRemoveLineItemFromCartMutation();

  const handleLineItemRemove = async () => {
    await removeLineItem({ cartId, lineItemId });

    track(analyticEvents.sidebar.remove, { productType });
  };

  return (
    <IconButton
      disabled={isRemoveLineItemLoading}
      onClick={handleLineItemRemove}
      data-cy="cart-line-item-remove-button"
      sx={{ mt: -1, mr: -1, color: brandColorTokens.icon.subtle }}
    >
      <DeleteOutlineIcon />
    </IconButton>
  );
};

export default RemoveLineItemButton;
